// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useEffect } from "react";
import { navigate, RouteComponentProps } from "@reach/router";
import logger from "../../../utils/logger";
import { authRedirectKey } from "../../../utils/Constant";
import { requestGetUserInfo } from "../../../state/auth/AuthEffects";
import { authentifiedUserEvent, logout } from "../../../state/auth/AuthEvents";
import { Spin } from "antd";
import { SpinIcon } from "../../components/SpinIcon";

const LoginCallback: React.FunctionComponent<RouteComponentProps> = () => {
  useEffect(() => {
    requestGetUserInfo.done.watch(({ result }) => {
      if (!!result.data) {
        logger.debug("LoginCallback success ", result.data);
        const authRedirect = sessionStorage.getItem(authRedirectKey);
        logger.debug("Post login redirect to ", authRedirect);
        authentifiedUserEvent(result.data);
        navigate(authRedirect !== null ? authRedirect : "/");
      } else if (result.responseCode === 403) {
        logger.error(
          "LoginCallback forbidden : ",
          result.responseCode,
          result.errorMessage
        );
        navigate("/forbidden");
        logout();
      } else {
        logger.error(
          "LoginCallback error : ",
          result.responseCode,
          result.errorMessage
        );
        navigate("/authError");
        logout();
      }
    });
  }, []);

  return (
    <div style={{ textAlign: "center" }}>
      <Spin indicator={SpinIcon} />
    </div>
  );
};

export default LoginCallback;
